<template>
  <!-- Shown only when a newer build is deployed and the app could not reload by itself (the client was
       typing, or a reload already failed to bring the new code). See src/appUpdate/versionCheck.ts. -->
  <Teleport to="body">
    <div v-if="updateAvailable" class="app-update" role="status" aria-live="polite" data-testid="app-update-banner">
      <span class="app-update__text">{{ t('app.update.available') }}</span>
      <button type="button" class="app-update__btn" data-testid="app-update-reload"
              @click="onReload">{{ t('app.update.action') }}</button>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { reloadToNewBuildByHand, updateAvailable } from '@/appUpdate/useAppUpdate';

const { t } = useI18n();

function onReload() {
  void reloadToNewBuildByHand();   // hides the banner at once, then reloads onto the deployed build
}
</script>

<style scoped lang="scss">
.app-update {
  position: fixed;
  top: max(12px, var(--app-safe-top));
  left: 50%;
  transform: translateX(-50%);
  z-index: 2100;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 16px;
  border-radius: var(--radius-pill);
  background: var(--bg-elev);
  color: var(--text);
  border: 1px solid var(--hairline-strong);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  font-size: 13px;
  font-weight: 500;
  width: max-content;
  max-width: calc(100vw - 32px);
}
.app-update__text {
  min-width: 0;
}
.app-update__btn {
  flex: none;
  padding: 6px 14px;
  border: 0;
  border-radius: var(--radius-pill);
  background: var(--gold);
  color: var(--text-inverse);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.app-update__btn:disabled {
  opacity: 0.6;
}
</style>
